module.exports = __webpack_public_path__ + "static/assets/06fd0604a4bf62a2b706edc23e49a086.mp3";